import { take } from 'rxjs/operators';
import { MmAlertMode, MmAlertService, MmAlertSize, MmAlertType } from '@metromarkets/components';
import { ScrollUtils } from '~shared/utils/scroll.utils';
import { TranslateService } from '@ngx-translate/core';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NUMBER_1 } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class TierOneRegistrationPromptService {
  titleSuccessfulRegistration = 'PAGES.AUTH.REGISTRATION.ALERT.SUCCESS.TITLE';

  messageSuccessfulRegistration = 'PAGES.AUTH.REGISTRATION.ALERT.SUCCESS.MESSAGE';

  constructor(
    private alertService: MmAlertService,
    private translateService: TranslateService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  promptSuccessFulRegistrationMessage() {
    this.translateService
      .get([this.titleSuccessfulRegistration, this.messageSuccessfulRegistration])
      // eslint-disable-next-line no-magic-numbers
      .pipe(take(1))
      .subscribe((translations) => {
        this.alertService.addAlert({
          type: MmAlertType.success,
          title: translations[this.titleSuccessfulRegistration],
          message: translations[this.messageSuccessfulRegistration],
          mode: MmAlertMode.banner,
          size: MmAlertSize.large,
          duration: 4000,
          contentAlign: 'center',
        });
        if (isPlatformBrowser(this.platformId)) {
          ScrollUtils.scrollTop();
        }
      });
  }

  promptError(errorMessageTitle) {
    this.translateService
      .get([errorMessageTitle])
      .pipe(take(NUMBER_1))
      .subscribe((translations) => {
        this.alertService.addAlert({
          type: MmAlertType.error,
          title: translations[errorMessageTitle],
          mode: MmAlertMode.banner,
          size: MmAlertSize.large,
          duration: 4000,
          contentAlign: 'center',
        });
      });
  }
}
